/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Project_File_Status_MetadataInputs */

const en_load_project_file_status_metadata = /** @type {(inputs: Load_Project_File_Status_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importing project metadata...`)
};

const fr_load_project_file_status_metadata = /** @type {(inputs: Load_Project_File_Status_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation des metadonnees du projet...`)
};

const de_load_project_file_status_metadata = /** @type {(inputs: Load_Project_File_Status_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projektmetadaten werden importiert...`)
};

const it_load_project_file_status_metadata = /** @type {(inputs: Load_Project_File_Status_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione dei metadati del progetto...`)
};

const ru_load_project_file_status_metadata = /** @type {(inputs: Load_Project_File_Status_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт метаданных проекта...`)
};

const es_load_project_file_status_metadata = /** @type {(inputs: Load_Project_File_Status_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importando metadatos del proyecto...`)
};

const zh_cn2_load_project_file_status_metadata = /** @type {(inputs: Load_Project_File_Status_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在导入项目元数据...`)
};

const ja_load_project_file_status_metadata = /** @type {(inputs: Load_Project_File_Status_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクト メタデータをインポートしています...`)
};

const hi_load_project_file_status_metadata = /** @type {(inputs: Load_Project_File_Status_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट मेटाडेटा आयात किया जा रहा है...`)
};

const pt_pt2_load_project_file_status_metadata = /** @type {(inputs: Load_Project_File_Status_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importando metadados do projeto...`)
};

/**
* | output |
* | --- |
* | "Importing project metadata..." |
*
* @param {Load_Project_File_Status_MetadataInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const load_project_file_status_metadata = /** @type {((inputs?: Load_Project_File_Status_MetadataInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Project_File_Status_MetadataInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_load_project_file_status_metadata(inputs)
	if (locale === "de") return de_load_project_file_status_metadata(inputs)
	if (locale === "it") return it_load_project_file_status_metadata(inputs)
	if (locale === "ru") return ru_load_project_file_status_metadata(inputs)
	if (locale === "es") return es_load_project_file_status_metadata(inputs)
	if (locale === "zh-CN") return zh_cn2_load_project_file_status_metadata(inputs)
	if (locale === "ja") return ja_load_project_file_status_metadata(inputs)
	if (locale === "hi") return hi_load_project_file_status_metadata(inputs)
	if (locale === "pt-PT") return pt_pt2_load_project_file_status_metadata(inputs)
	return en_load_project_file_status_metadata(inputs)
});